import {CSSProperties, FC} from 'react';


export interface IIconLightsFogBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLightsFogBmw: FC<IIconLightsFogBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M13.334 4c.322 0 .598.23.655.547l.068.37c.815 4.602.816 9.366.001 14.158l-.069.377a.667.667 0 0 1-.655.548C8.187 20 4 16.41 4 12c0-4.411 4.187-8 9.334-8ZM20 12a.666.666 0 0 1-.667.667h-1.49a10.35 10.35 0 0 0-.496 2.667h1.986a.666.666 0 1 1 0 1.333h-1.956c.042.442.108.842.188 1.182a.667.667 0 1 1-1.3.303 10.535 10.535 0 0 1-.224-1.485H16a.666.666 0 1 1 0-1.334h.012a11.5 11.5 0 0 1 .433-2.666H16a.666.666 0 1 1 0-1.333h.872c.31-.97.46-1.867.497-2.667h-1.37a.666.666 0 1 1 0-1.333h1.34a8.994 8.994 0 0 0-.188-1.182.666.666 0 1 1 1.298-.304c.099.422.18.926.226 1.486h.658a.666.666 0 1 1 0 1.333h-.63c-.032.81-.16 1.705-.432 2.667h1.062c.369 0 .667.298.667.666Z" clipRule="evenodd" />
        </svg>
    );
};
